/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { GraphiQL } from "graphiql";
import { Col, Row } from "react-awesome-styled-grid";
import styled from "styled-components";
import "graphiql/style.css";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { useCustomer } from "~/context";
import { useAuth0 } from "~/services";

export function ApiDocsPage() {
  const { getIdTokenClaims, checkSession } = useAuth0();
  const { customer } = useCustomer();

  const graphQLFetcher = async (graphQLParams: Record<string, unknown>) => {
    const token =
      (await getIdTokenClaims()) ||
      (await checkSession({ ignoreCache: true }), await getIdTokenClaims());

    return fetch(process.env.REACT_APP_GRAPHQL_ENDPOINT || "", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: token.__raw,
        "x-customer-id": customer?.id || "",
      },
      body: JSON.stringify(graphQLParams),
    }).then((response) => response.json());
  };

  return (
    <Row>
      <Col>
        <BreadcrumbsBox title="Fleet Control GraphQL API playground" />
        <div css={{ position: "relative" }}>
          <StyledGraphiqlContainer>
            <GraphiQL
              fetcher={graphQLFetcher}
              shouldPersistHeaders={false}
              defaultQuery="{ customers { id name } }"
            />
          </StyledGraphiqlContainer>
        </div>
      </Col>
    </Row>
  );
}

const StyledGraphiqlContainer = styled.div`
  .graphiql-container {
    min-height: 75vh;
  }
`;
